import { inject } from '@angular/core';
import { CanActivateChildFn } from '@angular/router';

import { AGENT_INFO_BFF_FLAG } from '@amfam/shared/utility/agent/lib/constants/agent-info.flag';
import { AgentCookieService } from '@amfam/shared/utility/agent/lib/services/agent-cookie.service';
import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access/lib/services/feature-flag.service';

// Registered as canActivateChild on the authenticated route, not canActivate: the route's own
// guards (login) have passed by the time its children are checked, so the request is authenticated.
// It never blocks navigation, and asks the BFF once per page load however often it runs.
export const agentCookieGuard: CanActivateChildFn = () => {
  if (inject(FeatureFlagService).isEnabled(AGENT_INFO_BFF_FLAG)) {
    inject(AgentCookieService).sync();
  }
  return true;
};
